export default __webpack_public_path__ + "static/media/ondemand.64ab4dbd.svg";